<template>
  <div class="form-page_instantor">
    <div class="tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <div id="itor"></div>
    <div class="has_declined_instantor_shower"><a id="has_declined_instantor" @click="skipInstantor">Omita este paso</a> (la probabilidad de confirmación aumenta si pasa este paso)</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Crezu from '@/utils/'

export default {
  name: 'Instantor',
  components: { InfoIcon },
  data () {
    return {
      inputVal: null
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      config: state => state.config,
      isDev: state => state.isDev,
      leadId: state => state.additionalParams.lead_id || localStorage.getItem('leadId') || localStorage.getItem('lead_id')
    })
  },
  mounted () {
    if (this.history[this.currentStep].name === 'moneyman_instantor') {
      if (window.skip_instantor_v2) {
        this.skipInstantor()
      } else {
        this.initializeInstantor(this.history[this.currentStep].name, this.history[this.currentStep].field.instantor_provider)
      }
    } else {
      this.$store.dispatch('getCustomerToken', this.history[this.currentStep].name).then((data) => {
        console.log('CUSTOMER TOKEN DATA:', data)
        let token = ''
        if (this.history[this.currentStep].name === 'twinero_instantor') token = data.data
        if (this.history[this.currentStep].name === 'welp_instantor') {
          token = Crezu.common.getURLParameter('userId', data.data)
        }
        this.initializeInstantor(this.history[this.currentStep].name, this.history[this.currentStep].field.instantor_provider, token)
      })
    }
  },
  methods: {
    initializeInstantor (name, provider, token) {
      console.log('init instantor for', name, provider, token)
      this.$loadScript('https://frame.euc1.instantor.com/instantor-0.7.3.min.js')
        .then(() => {
          console.log('INSTANTOR SCRIPT WAS LOADED')
          let instantorCallbackCalls = false
          let params = {}
          // eslint-disable-next-line
          let itor = new Instantor(provider)
          if (token) {
            if (name === 'twinero') params['applicationUuid'] = token
            if (name === 'welp') {
              params['userId'] = token
              itor.frameParam('disableFinalStep', 'true')
            }
          }
          params['firstName'] = this.$store.getters.getFieldValue('name') || localStorage.getItem('customerName')
          params['lastName'] = this.$store.getters.getFieldValue('surname') || localStorage.getItem('customerSurname')
          params['lead_id'] = this.leadId
          if (this.isDev) params['environment'] = 'stage'
          console.log('PARAMS:', params)
          for (let i in params) itor.userParam(i, params[i])
          itor.load('#itor')
          let vm = this
          itor.listener(function (response) {
            switch (response) {
              case 'process-finished':
                if (!instantorCallbackCalls) {
                  if (name === 'twinero_instantor' && localStorage.getItem('twinero_redirect_url')) {
                    vm.$store.dispatch('proceedRedirect', localStorage.getItem('twinero_redirect_url'))
                  }
                  vm.$store.commit('UPDATE_FIELD', { isValid: true })
                  vm.$store.commit('CHANGE_ADDITIONAL_PARAMS', { instantor_provided: true })
                  vm.$store.dispatch('nextStepPrepare', +1)
                  instantorCallbackCalls = true
                }
                break
              case 'invalid-login':
                /* User did not provide correct login credentials. */
                break
              default:
                /* Process encountered an error. */
                if (name === 'twinero_instantor' && localStorage.getItem('twinero_redirect_url')) {
                  vm.$store.dispatch('proceedRedirect', localStorage.getItem('twinero_redirect_url'))
                }
                break
            }
          })
        })
        .catch(() => {
          // Failed to fetch script
          console.log('failed to load instantor')
          this.skipInstantor()
        })
    },
    skipInstantor () {
      this.$store.commit('UPDATE_FIELD', { isValid: true })
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { instantor_provided: false })
      this.$store.dispatch('nextStepPrepare', +1)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/instantor";
</style>



// WEBPACK FOOTER //
// src/components/fields/Instantor.vue